import {Link, Text} from 'src/v2/components/common';

type LinkButtonProps = Parameters<typeof Link>[0];

export const LinkButton = ({children, ...props}: LinkButtonProps) => {
  return (
    <Link type="secondary" {...props}>
      <Text type="body">{children}</Text>
    </Link>
  );
};
